import { HttpStatusCode } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HeaderModule } from '@bcef/ia-components/header';
import { DataLayer } from '@difa/ia-data-layer';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'ia-simulateur-ppi-error',
  standalone: true,
  templateUrl: './error.component.html',
  imports: [TranslateModule, HeaderModule],
})
export class ErrorComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);

  private readonly translateService = inject(TranslateService);

  private code = '';

  private description = '';

  public ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.code = params['code'];
      this.description = this.getHttpStatusText(parseInt(this.code.trim().substring(0, 3), 10));
    });
    DataLayer.add('error', {
      type: 'PAGE',
      pathTitle: 'Credits conso/simulateur ppi',
      noStep: true,
      step: {
        title: `erreur ${this.code}`,
        isfirstStep: false,
        islastStep: false,
      },
      custom: {
        eVar40: `${this.code}|${this.description}`,
        eVar42: this.translateService.instant('screens.error.label'),
        eVar43: this.code.startsWith('5') ? 'Technique' : 'Fonctionnelle',
      },
    });
  }

  private getHttpStatusText(statusCode: number): string {
    const entries = Object.entries(HttpStatusCode);
    const match = entries.find(([_key, value]) => value === statusCode);
    return match ? this.splitCamelCase(match[0]) : '';
  }

  private splitCamelCase(text: string): string {
    return text.replace(/([a-z])([A-Z])/g, '$1 $2');
  }
}
